<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Overtakelse</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3">
      <v-textarea
        box
        v-model="stepValues.comment"
        @input="updateFields"
        label="Kommentar"
      ></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step]
}
</script>
